import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GarantizadosComponent } from './components/garantizados/garantizados.component';

const routes: Routes = [
  { path: 'garantizados', component: GarantizadosComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GarantizadosRoutingModule { }
